import { Injectable } from '@angular/core';
import { MailUtils } from '../utils/mail.utils';
import { TAGS } from '../models/constants';
import { EvaluationFlowsEnum } from '../models/shared.model';
import { AnalysisRun, AnalysisRunService } from './analysis-run.service';
import { ANALYSIS_TIMEOUTS, bounded, officeCall, AnalysisError } from '../utils/analysis-async';

@Injectable()
export class ImageService {
  constructor(private runs: AnalysisRunService) {}

  async loadImageTags(run: AnalysisRun = this.runs.current): Promise<Blob[]> {
    run.assertActive();
    if (!run.item) throw new AnalysisError('unavailable', 'No message selected');
    const body = await officeCall<string>(callback => run.item.body.getAsync(Office.CoercionType.Html, {}, callback),
      'Image body', run);
    const doc = MailUtils.parseHtmlResponse(body);
    const images = Array.from(doc.getElementsByTagName(TAGS.IMAGE));
    const blobs: Blob[] = [];
    for (let index = 0; index < images.length; index++) {
      run.assertActive();
      try { blobs.push(await this.fetchImageWithTimeout(images[index].getAttribute('src') || '', run)); }
      catch (error) {
        run.assertActive();
        run.issue(EvaluationFlowsEnum.QRCODE, error, `image:${index}`);
      }
    }
    return blobs;
  }

  private async fetchImageWithTimeout(url: string, run: AnalysisRun): Promise<Blob> {
    const controller = new AbortController();
    const cancel = () => controller.abort();
    run.signal.addEventListener('abort', cancel, { once: true });
    try {
      return await bounded(async () => {
        const response = await fetch(url, { mode: 'cors', signal: controller.signal });
        if (!response.ok) throw new AnalysisError('failed', 'Image download failed');
        return await response.blob();
      }, ANALYSIS_TIMEOUTS.image, 'Image download', run);
    } finally {
      controller.abort();
      run.signal.removeEventListener('abort', cancel);
    }
  }
}
